<template>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card p-0 widget-list-type2 h-full relative">

            <div class="overflow-y-auto" style="max-height: calc(120% - 120px)">

                <ul class="list-none pl-5 pr-5 pt-4">

                    <li class="flex align-items-center justify-content-between pt-2 pb-3">
                        <div class="flex align-items-center justify-content-start">
                            <img src="/layout/images/icon/rapor.svg" alt="verona-layout" height="42" class="border-round"/>
                            <div class="ml-2">
                                <span class="font-bold block">Hakediş Raporu</span>
                                <a href="/#/Report/FoodPaymentReport">
                                    <span class="subtext text-sm block">Listele</span>
                                </a>
                            </div>
                        </div>
                    </li>

                    <hr>

                    <li class="flex align-items-center justify-content-between pt-2 pb-3">
                        <div class="flex align-items-center justify-content-start">
                            <img src="/layout/images/icon/avans_toplam.svg" height="42" class="border-round"/>
                            <div class="ml-2">
                                <span class="font-bold block">Avans Ödemeleri</span>
                                <a href="/#/Accounting/AllowanceList">
                                    <span class="subtext text-sm block">Listele</span>
                                </a>
                            </div>
                        </div>
                    </li>

                    <hr>

                    <li class="flex align-items-center justify-content-between pt-2 pb-3">
                        <div class="flex align-items-center justify-content-start">
                            <img src="/layout/images/icon/resmi_odeme.svg" height="42" class="border-round"/>
                            <div class="ml-2">
                                <span class="font-bold block">Maaş Ödemeleri</span>
                                <a href="/#/Accounting/EmployeeSalaryList">
                                    <span class="subtext text-sm block">Listele</span>
                                </a>
                            </div>
                        </div>
                    </li>

                    <hr>

                    <li class="flex align-items-center justify-content-between pt-2 pb-3">
                        <div class="flex align-items-center justify-content-start">
                            <img src="/layout/images/icon/saat.svg" alt="verona-layout" height="42" class="border-round"/>
                            <div class="ml-2">
                                <span class="font-bold block">Mesai</span>
                                <a href="/#/Accounting/ProjectEmployeeOvertimeList">
                                    <span class="subtext text-sm block">Listele</span>
                                </a>
                            </div>
                        </div>
                    </li>

                    <hr>

                    <li class="flex align-items-center justify-content-between pt-2 pb-3">
                        <div class="flex align-items-center justify-content-start">
                            <img src="/layout/images/icon/pasif_personel.svg" alt="verona-layout" height="42" class="border-round"/>
                            <div class="ml-2">
                                <span class="font-bold block">Pasif Personel</span>
                                <a href="/#/Accounting/ProjectEmployeeHistoryList">
                                    <span class="subtext text-sm block">Listele</span>
                                </a>
                            </div>
                        </div>
                    </li>




                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserType } from '../../../pages/common/commonConstantFunctions';

export default {
    name: 'ShortcutsAdminDashboardPanel',
    data() {
        return {
            isAdmin:false,
        }
    },
    mounted() {
        if(getUserType() == 'Admin')
        {
            this.isAdmin = true;
        }
    },

}
</script>